import { countries } from './countries';

// NOTE: this is used as AntD doesn't support transforms within a dependency valueType
export const transformAddress = (addressList: any, flatten = false) => {
  // Ensure we always work with an array
  const list = Array.isArray(addressList) ? addressList : [addressList];

  const transformedAddressList = list.map((entry: any) => {
    const transformedAddress = entry.address.isManual
      ? { ...entry.address }
      : { ...JSON.parse(entry[`fullAddress-${entry.address.postcode}`]) };

    if (transformedAddress.townOrCity) {
      transformedAddress.town = transformedAddress.townOrCity;
      delete transformedAddress.townOrCity;
    }

    if (transformedAddress.country) {
      transformedAddress.countryCode = countries[transformedAddress.country.toLowerCase()]?.code || '';
    }

    delete transformedAddress.fullAddress;
    delete transformedAddress.isManual;

    // Apply flattening logic
    return flatten ? { ...transformedAddress } : { ...entry, address: transformedAddress };
  });

  // If input was a single object, return a single object
  return Array.isArray(addressList) ? transformedAddressList : transformedAddressList[0];
};
